@import '../../../../../node_modules/swiper/swiper';

ui-bank-search-mobile-slider {
  display: block;
  position: relative;
  height: 250px;
  pointer-events: auto;
  margin-bottom: $sd-spacing-8;

  &.condensed {
    height: 75px;
  }

  .swiper-wrapper {
    align-items: unset;
  }
}
